import { PaymentWidgetConfig, PaymentWidgetTheme } from './payment.type';
import { paymentWidgetConfig } from './payment.config';
import { getPaymentWidgetStyles } from 'src/components/PaymentWidget/payment.styles';

function getPaymentWidgetTheme(
  theme?: Partial<PaymentWidgetTheme>
): PaymentWidgetTheme {
  const windowSize = window.innerWidth;
  const customStyles = getPaymentWidgetStyles({ screenWidth: windowSize })

  if(theme) {
    return {
      ...paymentWidgetConfig.defaultThemeConfig,
      ...theme,
      styles: customStyles
    }
  }

  return {
    ...paymentWidgetConfig.defaultThemeConfig,
    styles: customStyles
  }
}

export function getPaymentWidgetConfig(theme?: Partial<PaymentWidgetTheme>): PaymentWidgetConfig {
  const widgetTheme = getPaymentWidgetTheme(theme);

  return {
    ...paymentWidgetConfig.global,
    custTheme: widgetTheme
  }
}
